import { TFunction } from 'react-i18next';
import { RecurrenceType } from '../Pages/Widget/Widget.types';
import getPriceForRepeatType from './getPriceForRepeatType';
import getFormattedDollarPrice from './getters/getFormattedDollarPrice';
import { AppointmentType } from './recurring';

export default function formatTotalPrice(
  t: TFunction<'translation'>,
  totalPrice: number,
  repeatMode?: RecurrenceType,
  appointmentType?: AppointmentType,
) {
  const recurringTypeTranslated = getPriceForRepeatType(t, repeatMode, appointmentType);

  if (recurringTypeTranslated) {
    return `${getFormattedDollarPrice(totalPrice)} / ${recurringTypeTranslated}`;
  }

  return getFormattedDollarPrice(totalPrice);
}
